// Common GROQ queries for marketing content
export const SITE_WIDE_SETTINGS_QUERY = `*[_type == "siteWideSettings"][0]{
  settings[]{
    _type,
    _type == "banner" => {
      text,
      background{
        ...,
      }
    }
  }
}`;
